import './styles/main.css';


import './scripts/calpak-helper-functions.js';

import './scripts/calpak-initialize.js';

import './scripts/slider.js';

import './scripts/global.js';
import './scripts/pdp.js';
import './scripts/variants.js';
import './scripts/pdp-gallery-thumbnails.js';
import './scripts/product-card.js';

import './scripts/quick-view.js';

import './scripts/pdp-buy-now.js';
import './scripts/theme-cart-shopify.js';

import './scripts/pdp-features.js';

import './scripts/custom-promo.js';
import './scripts/order-summary.js';
import './scripts/gift-card.js';

import initEightProductGrid from './scripts/eight-product-grid.js';

initEightProductGrid();
